import api from "@/api.js";
import apiV2 from "@/apiV2.js";

export default {
  modules: {},
  namespaced: true,
  state: {
    list: [],
    listLoading: false,
    current: null,
    currentLoading: false,
  },
  mutations: {
    setList(state, payload) {
      state.list = payload;
    },
    setListLoading(state, payload) {
      state.listLoading = payload;
    },
    setCurrent(state, payload) {
      state.current = payload;
    },
    setCurrentLoading(state, payload) {
      state.currentLoading = payload;
    },
  },
  actions: {
    async loadAll({ commit }, payload = {}) {
      commit("setListLoading", true);
      let list = await api.get("sustainability/storyCards", {
        params: payload,
      });
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async loadByID({ commit }, payload = {}) {
      commit("setCurrentLoading", true);
      let data = await api.get("sustainability/storyCards/byID", {
        params: payload,
      });
      commit("setCurrent", data.data[0]);
      commit("setCurrentLoading", false);
    },
    async createNew({ dispatch }, payload) {
      let returnData = {};

      await apiV2
        .post(`StoryCard`, payload)
        .then((response) => {
          if (response.data.result === "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            throw new Error();
          }
        })
        .catch(() => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later",
            },
          };
        });
      dispatch("loadAll");
      return returnData;
    },
    async updateExisting({ dispatch }, payload) {
      let returnData = {};

      await apiV2
        .put(`StoryCard/` + payload.id, payload)
        .then((response) => {
          if (response.data.result === "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            throw new Error();
          }
        })
        .catch(() => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later",
            },
          };
        });
      dispatch("loadAll");
      return returnData;
    },
    async delete({ dispatch }, payload) {
      let returnData = {};
      await api
        .post(`sustainability/storyCards/delete`, payload)
        .then((response) => {
          if (response.data.Result === "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data,
            };
          }
        })
        .catch(() => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later",
            },
          };
        });
      return returnData;
    },
  },
  getters: {
    list(state) {
      return state.list;
    },
    listLoading(state) {
      return state.listLoading;
    },
    listOrderedByRecent(state) {
      if(!Array.isArray(state.list)) return [];
      return state.list.sort((a, b) => {
        return new Date(b.created_at) - new Date(a.created_at);
      });
    },
    current(state) {
      return state.current;
    },
    currentLoading(state) {
      return state.currentLoading;
    },
  },
};
